import { render, staticRenderFns } from "./AssessTable.vue?vue&type=template&id=1ee67897&scoped=true"
import script from "./AssessTable.vue?vue&type=script&lang=js"
export * from "./AssessTable.vue?vue&type=script&lang=js"
import style0 from "./AssessTable.vue?vue&type=style&index=0&id=1ee67897&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee67897",
  null
  
)

export default component.exports